import React, { useEffect, useState } from "react";
import "./index.css";
import ProtocolTable from "./ProtocolTable";
import Disclaimer from "./Disclaimer";

const COPDReport = (props) => {
  const [apidata, setAPI] = useState();

  useEffect(() => {
    window.scrollTo(0, 0);
    const report = props.data.data;

    setAPI({
      referralToConsultant: report.referral_to_consultant,
      next_steps: report.next_steps,
      risk: report.risk,
      score: report.score,
      testsFollowUp: report.tests_follow_up,
      treatmentGoals: report.treatment_goals,
      labInvestigation: report.lab_investigation,
      educate: report.educate_on,
      diagnostics_imaging: report.diagnostics_imaging,
      risk_text: report.risk_text,
    });
  }, [props]);

  let riskCardColor = "";

  riskCardColor = !apidata
    ? "risk-low-color"
    : apidata.risk === "High Risk"
    ? "risk-high-color"
    : apidata.risk === "Moderate Risk" || apidata.risk === "Medium Risk"
    ? "risk-medium-color"
    : "risk-low-color";

  return (
    <div>
      {apidata && (
        <div className="new-report-container">
          <div className="new-report-card">
            <h2 className="report-card-title">
              AI Calculated Risk Score Based on Your Inputs
            </h2>
            <div className="risk-section">
              <div className="copd-risk-cards">
                <div className="risk-card">
                  <h3 className="risk-card-title">Risk Status</h3>
                  <div className={`${riskCardColor} risk-highlight`}>
                    {apidata.risk}
                  </div>
                </div>
                <div className="risk-card">
                  <h3 className="risk-card-title">Risk Score </h3>
                  <p className="risk-value">{apidata.risk_text}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="new-report-card">
            <h2 className="report-card-title">AI Recommended Protocol</h2>
            <ProtocolTable data={apidata} />
          </div>
          <div className="new-report-card">
            <h2 className="report-card-title">Disclaimer</h2>
            <Disclaimer />
          </div>
        </div>
      )}
    </div>
  );
};

export default COPDReport;
